
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Créer un site Internet de métallerie ferronnerie : exemples, prix et délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "À l’heure du numérique, tout artisan doit développer sa présence sur le Web. Cette nécessité vaut pour une société de métallerie ferronnerie. Site Internet, page Facebook, page LinkedIn ou même blog, un professionnel doit exploiter tous les outils numériques à disposition pour booster sa visibilité sur la Toile. On vous explique tout.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet de métallerie ferronnerie : exemples, prix et délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "À l’heure du numérique, tout artisan doit développer sa présence sur le Web. Cette nécessité vaut pour une société de métallerie ferronnerie. Site Internet, page Facebook, page LinkedIn ou même blog, un professionnel doit exploiter tous les outils numériques à disposition pour booster sa visibilité sur la Toile. On vous explique tout.",
        },
      ],
    };
  },
};
